/**
 * Created by yangxuanbin on 05/02/2018
 **/
import { combineReducers } from 'redux';

//引入的reducers
import userInfo from './userInfo'
import setRole from './role'
import positionInfo from './positionInfo'

const rootReducer = combineReducers({
  userInfo,
  setRole,
  positionInfo
});
export default rootReducer


// WEBPACK FOOTER //
// ./src/reduxModule/reducers/index.js